/**
 * Boutique-hotels template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ThemeLogoMarquee from './lib/partials/ThemeLogoMarquee';
import ThemeBusinessMap from './lib/partials/ThemeBusinessMap';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Boutique-hotels';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initThemeLogoMarquees();
	initThemeBusinessMap();
}

/**
 * initThemeBusinessMap - Initialize the ThemeBusinessMap
 **/
const initThemeBusinessMap = () => {
	Logger.info(`${NAME} > initThemeBusinessMap`);

	const dom = document.querySelector(`[data-theme-business-map]`);
	if (!dom) return;

	const themeBusinessMap = new ThemeBusinessMap(dom);
	themeBusinessMap.init();
}


/**
 * initThemeLogoMarquees - Initialize the theme logo marquee
 */
const initThemeLogoMarquees = () => {
	Logger.info(`${NAME} > initThemeLogoMarquees`);
	const themeLogoMarquees = document.querySelectorAll('[data-theme-logo-marquee]');
	if (!themeLogoMarquees) return;
	themeLogoMarquees.forEach(themeLogoMarquee => {
		const el = new ThemeLogoMarquee(themeLogoMarquee);
		el.init();
	});
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
